import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from '@gympass/yoga'
import { useHistory } from 'react-router-dom'

import { SmallBusiness, MediumBusiness, LargeBusiness } from '@assets/icons'

import useDataLayer from '@hooks/useDataLayer'
import useRouteBuilder from '@hooks/useRouteBuilder'

import * as Style from './CompanyPlans.style'
import * as HomeStyle from '../../Home.style'

export default function CompanyPlans() {
  const { events, values } = useDataLayer()
  const history = useHistory()
  const { buildRoute } = useRouteBuilder()

  function handleDataLayerEvent(label) {
    events.simulatorInteraction(label)

    if (label !== values.LARGE_BUSINESS_PLAN_CARD) {
      history.push(buildRoute('simulate/company-info'))
    }
  }

  return (
    <Style.Wrapper>
      <HomeStyle.Container>
        <Style.Title>
          <FormattedMessage id="smb_acquisition_home.company_plans.title" />
        </Style.Title>
        <Style.Subtitle>
          <FormattedMessage id="smb_acquisition_home.company_plans.subtitle" />
        </Style.Subtitle>

        <Style.CardWrapper>
          <Style.Card>
            <Style.CardIcon
              src={SmallBusiness}
              alt="Uma lojinha pequena com uma única portinha e um toldo azul"
            />
            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_1.title" />
            </Style.CardTitle>
            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_1.subtitle" />
            </Style.CardSubtitle>
            <Style.PriceWrapper>
              <Style.PriceTitle>
                <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_1.value_title" />
              </Style.PriceTitle>
              <Style.Price>
                R$
                <span>
                  <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_1.value" />
                </span>
                /
                <FormattedMessage id="smb_acquisition_home.company_plans.plans.frequency_adjective" />
              </Style.Price>
            </Style.PriceWrapper>
            <Button
              full
              onClick={() =>
                handleDataLayerEvent(values.SMALL_BUSINESS_PLAN_CARD)
              }
            >
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_1.call_to_action.default" />
            </Button>
          </Style.Card>

          <Style.Card>
            <Style.CardIcon
              src={MediumBusiness}
              alt="Um prédio baixo com três andares"
            />
            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_2.title" />
            </Style.CardTitle>
            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_2.subtitle" />
            </Style.CardSubtitle>
            <Style.PriceDescription>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_2.value" />
            </Style.PriceDescription>
            <Button
              full
              onClick={() =>
                handleDataLayerEvent(values.MEDIUM_BUSINESS_PLAN_CARD)
              }
            >
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_2.call_to_action.default" />
            </Button>
          </Style.Card>

          <Style.Card>
            <Style.CardIcon
              src={LargeBusiness}
              alt="Um shopping com vários prédios pequenos"
            />
            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_3.title" />
            </Style.CardTitle>
            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_3.subtitle" />
            </Style.CardSubtitle>
            <Style.PriceDescription>
              <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_3.value" />
            </Style.PriceDescription>
            <Style.LargeCompaniesLink
              href="https://hs.gympass.com/pt-br/contactus-lp?utm_source=website&utm_medium=button&utm_campaign=hands-up-SMB-BR"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                full
                onClick={() =>
                  handleDataLayerEvent(values.LARGE_BUSINESS_PLAN_CARD)
                }
              >
                <FormattedMessage id="smb_acquisition_home.company_plans.plans.plan_3.call_to_action.default" />
              </Button>
            </Style.LargeCompaniesLink>
          </Style.Card>
        </Style.CardWrapper>

        <Style.Body1>
          <FormattedMessage id="smb_acquisition_home.company_plans.description" />
        </Style.Body1>
      </HomeStyle.Container>
    </Style.Wrapper>
  )
}
